import { API_SCHEDULE_STATUSES, API_SERVICE_TYPES } from '@/constants';
import _ from 'lodash';

const filterLawnMowingSchedule = ({ schedules }) => {
  if (!schedules) return {};
  return (
    schedules.find(
      ({ status, service = {} }) =>
        service.service_id === 1 &&
        service.str_id === API_SERVICE_TYPES.MOWING &&
        status === API_SCHEDULE_STATUSES.ACTIVE
    ) || {}
  );
};

const hasCancellableMowing = ({ property }) =>
  !_.isNil(property.active_mowing_schedule_id) && property.can_cancel_mowing_services;

export const lsPropertyHelpers = {
  filterLawnMowingSchedule,
  hasCancellableMowing,
};
